import heart from 'public/static/images/srp/heart.svg';
import whiteHeart from 'public/static/images/srp/white-heart.svg';
import { colors } from 'components/styles/variables';
import classNames from 'classnames';
import { ButtonHTMLAttributes } from 'react';
import { useHover } from 'react-use';

interface FavoriteIconProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  active: boolean;
  className?: string;
}

export default function FavoriteIcon({
  className,
  active,
  onClick,
  ...props
}: FavoriteIconProps): JSX.Element {
  const [favoriteIconButton] = useHover((hovered) => (
    <button className={classNames('favorite-icon-button')} onClick={onClick} {...props}>
      <img
        data-testid="favorite-heart"
        className={classNames('favorite-heart')}
        src={hovered || active ? heart : whiteHeart}
        alt="favorite"
      />
      <style jsx>{`
        .favorite-icon-button {
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          height: 40px;
          width: 40px;
          border: none;
          border-radius: 8px;
          background-color: ${active ? colors.WHITE : `rgba(0, 0, 0, 0.6)`};
          box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
        }
      `}</style>
    </button>
  ));

  return (
    <>
      <div className={classNames('favorite-icon-button-container', className)}>
        {favoriteIconButton}
      </div>
      <style jsx>{`
        .favorite-icon-button-container {
          position: absolute;
          top: 12px;
          right: 12px;
          z-index: 9;
        }
      `}</style>
    </>
  );
}
